/* eslint-disable jsx-a11y/anchor-is-valid */

import { Layout } from "../widgets/components/General/Layout"


export const AuthLayout = () => {

 return <Layout/>
}


